const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

export function numberOfDaysInMonth(date) {
  let month = date.getMonth();
  let year = date.getYear();
  return 32 - new Date(year, month, 32).getDate();
}

export function addDay(date, amount) {
  amount = -amount;
  let time = date.getTime();
  return new Date(time - MILLISECONDS_IN_DAY * amount);
}
export function getFirstSunday(date) {
  // returns a negative index related to the 1st of the month
  let newDate = new Date(date.getTime());
  newDate.setDate(1);
  return -newDate.getDay();
}

export function isLeapYear(dateOrYear) {
  const year =
    dateOrYear instanceof Date ? dateOrYear.getFullYear() : dateOrYear;
  return !(year % 400) || (!(year % 4) && !!(year % 100));
}

export function dateCopy(date) {
  if (isValidDateObject(date)) {
    return new Date(date.getTime());
  }
  return date;
}

function isValidDateObject(date) {
  if (typeof date === 'object' && date instanceof Date) {
    let ms = date.getTime();
    return !isNaN(ms);
  }
  return false;
}
